'use client';

import { Instance } from '@/editora/Instance';
import { Carousel } from '@mage-ui/components';
import { useContext } from 'react';
import { useCallback, useEffect, useRef, useState } from 'react';
import { StaticTextContext } from '../context/StaticTextProvider';

export const InstancesCarousel = ({ instances = [], settings, ...props }) => {
  const containerRef = useRef(null);
  const [showIndicators, setShowIndicators] = useState(false);
  const { st } = useContext(StaticTextContext);

  const checkOverflow = useCallback(() => {
    if (!containerRef.current) {
      return;
    }
    const viewport = containerRef.current.querySelector('.carousel-viewport');
    const slides = containerRef.current.querySelectorAll('.carousel-slide');
    const container = containerRef.current.querySelector('.carousel-container');
    if (!container) {
      return;
    }
    //possar la var slide-spacing que hi ha entre slides i convertir a px
    const containerStyles = window.getComputedStyle(container);
    const slideSpacing =
      Number.parseFloat(containerStyles.getPropertyValue('--slide-spacing')) ||
      0;
    const rootFontSize =
      Number.parseFloat(getComputedStyle(document.documentElement).fontSize) ||
      16;
    const slideSpacingInPx = slideSpacing * rootFontSize;

    if (viewport && slides.length > 0) {
      const totalSlidesWidth = Array.from(slides).reduce((acc, slide) => {
        const rect = slide.getBoundingClientRect();
        return acc + rect.width;
      }, 0);

      const viewportWidth = viewport.getBoundingClientRect().width;

      setShowIndicators(totalSlidesWidth > viewportWidth + slideSpacingInPx);
    }
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      checkOverflow();
    }, 100);

    window.addEventListener('resize', checkOverflow);

    return () => {
      clearTimeout(timeout);
      window.removeEventListener('resize', checkOverflow);
    };
  }, [checkOverflow]);

  return (
    <div ref={containerRef}>
      {instances.length <= 1 ? (
        instances.map((instance) => (
          <Instance
            key={instance?.meta?.key || instance?.meta?.id}
            instance={instance}
            {...props}
          />
        ))
      ) : (
        <Carousel
          emblaOptions={{
            loop: true,
            dragFree: false,
            align: 'center',
          }}
          withIndicators={showIndicators}
          classNames={{ settings }}
          previousControl={{
            label: st('carousel.previous'),
          }}
          nextControl={{
            label: st('carousel.next'),
          }}
          indicatorControl={{
            label: st('carousel.slide'),
            ofLabel: st('carousel.slide_of'),
          }}
          {...props}
        >
          {instances.map((instance) => (
            <Carousel.Slide key={instance?.meta?.key || instance?.meta?.id}>
              <Instance instance={instance} {...props} />
            </Carousel.Slide>
          ))}
        </Carousel>
      )}
    </div>
  );
};
